import { isAutomationTest } from 'shared/test-utils/automation-test';

const shouldInstallHeapAnalytics = () => {
    // install heap only on production and exclude automation tests
    return !isAutomationTest() && window.location.origin.includes('placer.ai');
};

export const installHeapAnalytics = () => {
    if (shouldInstallHeapAnalytics()) {
        const head = document.head || document.getElementsByTagName('head')[0];
        const heapScript = document.createElement('script');
        heapScript.type = 'text/javascript';
        heapScript.innerHTML = `
        window.heapReadyCb = window.heapReadyCb || [];
        window.heap = window.heap || [];
        
        heap.load = function(e, t) {
            window.heap.envId = e;
            window.heap.clientConfig = t = t || {};
            window.heap.clientConfig.shouldFetchServerConfig = false;
            
            var a = document.createElement("script");
            a.type = "text/javascript";
            a.async = true;
            a.src = "https://cdn.us.heap-api.com/config/" + e + "/heap_config.js";
            
            var r = document.getElementsByTagName("script")[0];
            r.parentNode.insertBefore(a, r);
            
            var n = [
                "init",
                "startTracking",
                "stopTracking",
                "track",
                "resetIdentity",
                "identify",
                "identifyHashed",
                "getSessionId",
                "getUserId",
                "getIdentity",
                "addUserProperties",
                "addEventProperties",
                "removeEventProperty",
                "clearEventProperties",
                "addAccountProperties",
                "addAdapter",
                "addTransformer",
                "addTransformerFn",
                "onReady",
                "addPageviewProperties",
                "removePageviewProperty",
                "clearPageviewProperties",
                "trackPageview"
            ];
            
            var i = function(e) {
                return function() {
                    var t = Array.prototype.slice.call(arguments, 0);
                    window.heapReadyCb.push({
                        name: e,
                        fn: function() {
                            heap[e] && heap[e].apply(heap, t);
                        }
                    });
                };
            };
            
            for (var p = 0; p < n.length; p++) {
                heap[n[p]] = i(n[p]);
            }
        };
        
        heap.load("1210352797");
    `;
        head.appendChild(heapScript);
    }
};
